import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@components/ui/sidebar";
import { BarChart3Icon, BookmarkIcon, SearchIcon } from "lucide-react";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";
import { FEATURE } from "@/features";
import { Feature } from "@components/Feature";
import AccessControl from "@components/AccessControl";

export function MainNav({
  orgUuid,
  pathname,
}: {
  orgUuid: string;
  pathname: string;
}) {
  const searchLink = generatePath(ROUTES.SEARCH_ORGID, { orgUuid });
  const reportsLink = generatePath(ROUTES.REPORTS_ORGID, { orgUuid });
  const favoritesLink = generatePath(ROUTES.FAVORITES_ORGID, { orgUuid });

  return (
    <SidebarGroup>
      <SidebarMenu>
        <AccessControl>
          <Feature required={FEATURE.HAS_SEARCH_PRODUCT} upsale>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                isActive={pathname === searchLink}
                id="explore-button"
                data-testid="explore-button"
              >
                <Link to={searchLink}>
                  <SearchIcon />
                  <Trans>Sök</Trans>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </Feature>
        </AccessControl>

        <Feature required={FEATURE.HAS_REPORT_PRODUCT} upsale>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              isActive={pathname === reportsLink}
              id="reports-button"
              data-testid="reports-button"
            >
              <Link to={reportsLink}>
                <BarChart3Icon />
                <Trans>Rapporter</Trans>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </Feature>

        <SidebarMenuItem>
          <SidebarMenuButton
            asChild
            isActive={pathname === favoritesLink}
            id="favorites-button"
            data-testid="favorites-button"
          >
            <Link to={favoritesLink}>
              <BookmarkIcon />
              <Trans>Sparade omnämnanden</Trans>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
